import "./send-form.css";
import Cleave from "cleave.js/react";
import "cleave.js/dist/addons/cleave-phone.i18n.js";
import { useRef, useState } from "react";
import { ReactComponent as AfterSend } from "../../svg/afterSend_anim.svg";

const SendForm = (props) => {
  const name = useRef();
  const phone = useRef();
  const [isSend, setIsSend] = useState(false);

  return (
    <div className={props.classType == "homeByKey" ? "home_selectByKey_recall" : "home_phone_recall"}>
      {!isSend ? (
        <>
          <div className={props.classType == "homeByKey" ? "home_selectByKey_recall_title" : "home_phone_recall_title"}>
            {props.classType == "homeByKey" ? (
              <>
                <span className="home_selectByKey_recall_title">
                  Закажите подбор под<font>{" Ключ"}</font>
                </span>
              </>
            ) : (
              <>
                <div>{props.titleFirst}</div>
                <div>{props.titleSecond}</div>
              </>
            )}
          </div>

          <div className="home_phone_recall_clientInfo">
            <div className="home_phone_recall_clientInfo_inputs">
              <input
                ref={name}
                placeholder={props.firstInputPlaceholder}
              />
              <Cleave
                ref={phone}
                type="tel"
                placeholder={props.secondInputPlaceholder}
                options={{
                  numericOnly: true,
                  delimiters: ["", ") ", " - ", " - "],
                  blocks: [3, 3, 3, 2, 2],
                  prefix: "+7(",
                  noImmediatePrefix: true,
                }}
              />
            </div>
            <div className="home_phone_recall_clientInfo_buttons">
              <div
                className="home_phone_recall_clientInfo_button"
                onClick={() => {
                  fetch("http://170.168.118.141:8080/api/telegram-bot/sendTask", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      type: props.taskType,
                      name: name.current.value,
                      phone: phone.current.state.value,
                    }),
                  })
                    .then((out) => out.json())
                    .then((out) => setIsSend(true))
                    .catch((err) => console.log(err));
                }}
              >
                Отправить
              </div>
              <div className="home_phone_recall_clientInfo_agrees">
                Нажимая на кнопку, вы даете{" "}
                <a
                  style={{ textDecoration: "underline" }}
                  target="_blank"
                  href={"http://" + window.location.host + "/documents/personal_info_agreement"}
                >
                  согласие на обработку персональных данных
                </a>
                , разрешенных для передачи
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className={props.classType == "homeByKey" ? "sendForm_tick dark" : "sendForm_tick"}>
          <AfterSend />
          <span>Мы с Вами свяжемся в ближайшее время!</span>
        </div>
      )}
    </div>
  );
};

export default SendForm;
